// Apresentação humana das ações (tools) do Captain, para a aba "O que pode
// fazer" (02/09/2026). Quem lê é quem configura, não quem programou: nome curto,
// o que a ação faz e um exemplo do resultado. Tool sem entrada aqui aparece com
// o título técnico e o selo "técnica", nunca some.
export const APRESENTACAO_ACOES = {
  faq_lookup: {
    nome: 'Responder com as perguntas frequentes',
    oQueFaz: 'Procura na lista de perguntas aprovadas antes de responder.',
    exemplo: '"Qual o horário?" recebe a resposta exata cadastrada.',
  },
  handoff: {
    nome: 'Passar para uma pessoa',
    oQueFaz:
      'Transfere a conversa para a equipe quando não deve seguir sozinha.',
    exemplo: 'Cliente pede desconto fora da tabela: ela chama um atendente.',
  },
  move_kanban_stage: {
    nome: 'Mover no Kanban',
    oQueFaz: 'Leva o cliente para a etapa certa do funil.',
    exemplo: 'Visita marcada: o cartão vai para "Visita agendada".',
  },
  schedule_appointment: {
    nome: 'Agendar compromisso',
    oQueFaz: 'Marca visita, reunião ou ligação na agenda da equipe.',
    exemplo: '"Pode ser quinta às 15h?" vira um compromisso na agenda.',
  },
  cancel_appointment: {
    nome: 'Cancelar compromisso',
    oQueFaz: 'Cancela um compromisso quando o cliente desmarca.',
    exemplo: '"Não vou conseguir ir" cancela a visita e avisa a equipe.',
  },
  reschedule_appointment: {
    nome: 'Remarcar compromisso',
    oQueFaz: 'Troca a data ou o horário de um compromisso existente.',
    exemplo: '"Dá pra passar pra sexta?" remarca sem criar outro.',
  },
  list_appointments: {
    nome: 'Ver compromissos',
    oQueFaz: 'Consulta os compromissos do cliente para não marcar em cima.',
    exemplo: 'Antes de propor horário, vê o que já está marcado.',
  },
  get_purchase_history: {
    nome: 'Ver histórico de compras',
    oQueFaz: 'Consulta o que o cliente já comprou ou assinou.',
    exemplo:
      'Cliente pergunta do acesso: ela vê o plano ativo antes de responder.',
  },
  update_lead_info: {
    nome: 'Anotar dados do cliente',
    oQueFaz: 'Preenche a ficha com o que o cliente contou na conversa.',
    exemplo: 'Cidade e faixa de valor entram nos campos sem digitar.',
  },
  update_conversation_info: {
    nome: 'Anotar dados da conversa',
    oQueFaz: 'Preenche campos da conversa (assunto, interesse, prioridade).',
    exemplo: 'Marca o interesse como "aluguel" quando o cliente diz.',
  },
  offer_catalog: {
    nome: 'Consultar o catálogo',
    oQueFaz:
      'Busca produtos ou planos cadastrados para responder com preço e condição.',
    exemplo: '"Quanto custa o plano anual?" vem do catálogo, não de memória.',
  },
  attach_offer: {
    nome: 'Enviar oferta',
    oQueFaz: 'Manda uma oferta do catálogo com link de pagamento quando cabe.',
    exemplo: 'Cliente decidiu: recebe a oferta certa com o link.',
  },
  send_material: {
    nome: 'Enviar material',
    oQueFaz:
      'Manda um arquivo cadastrado na aba O que sabe (tabela, contrato, apresentação).',
    exemplo: '"Me manda a tabela" envia o PDF cadastrado.',
  },
  check_messaging_window: {
    nome: 'Conferir a janela do WhatsApp',
    oQueFaz:
      'Verifica se ainda pode mandar mensagem livre ou se precisa de modelo.',
    exemplo: 'Passou de 24 horas: ela não tenta enviar texto solto.',
  },
  get_working_hours: {
    nome: 'Conferir o horário de atendimento',
    oQueFaz: 'Lê o expediente da caixa para responder certo sobre horários.',
    exemplo: '"Vocês abrem sábado?" sai do horário cadastrado.',
  },
  generate_image: {
    nome: 'Gerar imagem',
    oQueFaz: 'Cria uma imagem quando a conversa pede (simulação, ilustração).',
    exemplo: 'Monta uma imagem do ambiente com o produto.',
  },
  read_document: {
    nome: 'Ler documento enviado',
    oQueFaz: 'Lê PDF ou imagem que o cliente mandou e usa o conteúdo.',
    exemplo: 'Cliente manda a fatura: ela lê o valor e responde.',
  },
  web_fetch: {
    nome: 'Consultar uma página da internet',
    oQueFaz: 'Abre um link para conferir informação pública.',
    exemplo: 'Confere o endereço no site da prefeitura.',
  },
  calculator: {
    nome: 'Fazer contas',
    oQueFaz: 'Calcula parcelas, percentuais e totais sem errar.',
    exemplo: '"Quanto fica em 12x?" sai certo.',
  },
  lookup_cep: {
    nome: 'Consultar CEP',
    oQueFaz: 'Descobre endereço pelo CEP ou o CEP pelo endereço.',
    exemplo: 'Cliente manda o CEP: ela preenche cidade e bairro.',
  },
  lookup_cnpj: {
    nome: 'Consultar CNPJ',
    oQueFaz: 'Busca razão social e situação de uma empresa pelo CNPJ.',
    exemplo: 'Empresa cliente: ela confirma o nome antes da proposta.',
  },
  transfer_to_assistant: {
    nome: 'Passar para outra assistente',
    oQueFaz: 'Encaminha para a assistente certa quando o assunto é de outra.',
    exemplo: 'Suporte pergunta de venda: vai para a assistente comercial.',
  },
  mark_do_not_contact: {
    nome: 'Marcar "não contatar"',
    oQueFaz: 'Registra que a pessoa não quer mais receber mensagens.',
    exemplo: '"Não me mande mais nada" para as próximas campanhas.',
  },
  schedule_follow_up: {
    nome: 'Programar uma retomada',
    oQueFaz: 'Agenda uma mensagem futura para retomar a conversa.',
    exemplo: '"Me chama semana que vem" vira lembrete automático.',
  },
  resolve_conversation: {
    nome: 'Encerrar a conversa',
    oQueFaz: 'Marca a conversa como resolvida quando o assunto acabou.',
    exemplo: 'Cliente agradece e encerra: a conversa sai da fila.',
  },
  calculate_economy: {
    nome: 'Calcular economia (energia solar)',
    oQueFaz: 'Estima a economia na conta de luz a partir do consumo.',
    exemplo: 'Conta de R$ 480 vira uma estimativa de economia mensal.',
  },
  extract_bill: {
    nome: 'Ler a conta de luz (energia solar)',
    oQueFaz: 'Lê a fatura enviada e extrai consumo e distribuidora.',
    exemplo: 'Foto da conta: ela pega o kWh e a concessionária.',
  },
};

export const apresentarAcao = tool => {
  const humana = APRESENTACAO_ACOES[tool?.id];
  if (humana) return { ...humana, tecnica: false, id: tool.id };
  return {
    id: tool?.id,
    nome: tool?.title || tool?.id || '',
    oQueFaz: tool?.description || '',
    exemplo: '',
    tecnica: true,
  };
};
